/**
 * Microsoft Clarity — mapas de calor + grabaciones de sesión.
 *
 * <p>Gated por consent RGPD igual que New Relic: solo se carga cuando el user
 * acepta cookies analíticas (ver `main.tsx` / `App.tsx`). Clarity **graba
 * sesiones** (más invasivo que Umami/NR) → NUNCA cargar sin opt-in
 * explícito. El enmascarado de texto se controla en el panel de Clarity (ON
 * por defecto) para no capturar PII de forms/chat.</p>
 *
 * <p>Solo arranca en el dominio de producción real (`matchplay.es` / `www`),
 * así queda fuera de dev, staging (`dev.matchplay.es`), preview y tests (jsdom
 * corre en `localhost`). El Project ID es **público** (viaja en el bundle a
 * cada visitante), así que no es un secreto ni necesita env var.</p>
 */

const CLARITY_PROJECT_ID = 'xiavifn5c2'
const PROD_HOSTS = new Set(['matchplay.es', 'www.matchplay.es'])

type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[][] }

declare global {
  interface Window {
    clarity?: ClarityFn
  }
}

let initialized = false

/**
 * Inyecta el tag de Microsoft Clarity una sola vez por carga de página.
 * Idempotente y no-op fuera del dominio de producción.
 *
 * @returns true si quedó inicializado, false si se saltó.
 */
export function initClarity(): boolean {
  if (initialized) return true
  if (typeof window === 'undefined') return false
  if (!PROD_HOSTS.has(window.location.hostname)) return false
  if (window.clarity) {
    initialized = true
    return true
  }

  // Stub que encola llamadas en `.q` hasta que el tag remoto carga y las
  // consume — equivalente al loader oficial de Clarity, pero inyectado por
  // código para respetar el gate de consent (no un snippet fijo en <head>).
  const queue: unknown[][] = []
  const clarity = ((...args: unknown[]) => {
    queue.push(args)
  }) as ClarityFn
  clarity.q = queue
  window.clarity = clarity

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`
  document.head.appendChild(script)

  initialized = true
  return true
}
